var map = {
	"./Alice's_Adventures_in_Wonderland_analysis.json": 282,
	"./a_christmas_carol_analysis.json": 283,
	"./anne_of_green_gables_analysis.json": 284,
	"./dr_jekyll_and_mr_hyde_analysis.json": 285,
	"./jane_eyre_analysis.json": 286,
	"./little_women_analysis.json": 287,
	"./pride_and_prejudice_analysis.json": 288,
	"./winnie_the_pooh_analysis.json": 289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;